// Enumerations
import { WebSocketPayloadStatusEnumeration } from 'enumerations/wbsocket-payload-status.enumeration';

const WS_PROOF_INCOME_TRACKING_ERROR = {
  errorDescription: `Error retrieving income data from WS: ${WebSocketPayloadStatusEnumeration.REJECTED}`,
  errorStatus: `${WebSocketPayloadStatusEnumeration.REJECTED}`,
};
const COMPLETE_OPENBANKING_TRACKING_ERROR = {
  errorDescription: 'Error completing openbanking process',
  errorStatus: 'ERROR',
};

const INVALIDATE_OPENBANKING_TRACKING_ERROR = {
  errorDescription: 'Error invalidating openbanking process',
  errorStatus: 'ERROR',
};

export {
  COMPLETE_OPENBANKING_TRACKING_ERROR,
  INVALIDATE_OPENBANKING_TRACKING_ERROR,
  WS_PROOF_INCOME_TRACKING_ERROR,
};
